import { Redirect } from 'expo-router';
import Head from 'expo-router/head';

import { LoyaltyRewardsListWidget as LoyaltyRewardsListItemPage } from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-widgets/loyalty-rewards-list-widget';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function RewardsItemPage() {
  const enableRewardsTiers = useFlag('enable-rewards-tiers');

  if (enableRewardsTiers) {
    return <Redirect href={routes.offersV2} />;
  }

  return (
    <>
      <Head>
        <title>Reward - Firehouse Subs</title>
      </Head>
      <LoyaltyRewardsListItemPage />
    </>
  );
}
